import { createContext } from 'react';

export type ReportServerResponseStatus = (statusCode: number) => void;

const ServerResponseStatusContext = createContext<ReportServerResponseStatus | undefined>(undefined);

export default ServerResponseStatusContext;
